module.exports = __webpack_public_path__ + "static/img/pjmr-lct-e.52e61a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/pjmr-lct-e.png
// module id = oPLI
// module chunks = 15